import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, X } from "lucide-react";

export default function AdminTestimonials() {
  const [items, setItems] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ name: "", role: "", message: "", avatar_url: "", rating: 5, source: "", source_url: "" });

  const load = () => api.get("/admin/testimonials").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/admin/testimonials", { ...form, rating: parseInt(form.rating) });
      toast.success("Saved");
      setShow(false); load();
    } catch (e) { toast.error(apiError(e)); }
  };
  const del = async (id) => {
    if (!confirm("Delete?")) return;
    await api.delete(`/admin/testimonials/${id}`); load();
  };

  return (
    <div data-testid="admin-testimonials">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.3em] brand-orange mb-3">// CMS · Testimonials</div>
          <h1 className="font-display text-4xl font-black uppercase tracking-tighter leading-none">Testimonials.</h1>
        </div>
        <button onClick={() => setShow(true)} data-testid="new-testimonial-btn" className="bg-brand-blue text-white px-5 py-2 text-xs uppercase font-bold tracking-widest flex items-center gap-2">
          <Plus size={12} /> New
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {items.map((t) => (
          <div key={t.id} className="border border-white/12 bg-[#131A2B] p-5">
            <div className="flex justify-between items-start">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="flex gap-1">{Array.from({ length: t.rating }).map((_, i) => <span key={i} className="brand-blue text-xs">★</span>)}</div>
                  {(t.source || "").toLowerCase() === "google" && (
                    <span className="text-[9px] font-mono uppercase tracking-widest bg-white text-[#0B1120] px-1.5 py-0.5">Google</span>
                  )}
                </div>
                <p className="text-white/80 text-sm">&ldquo;{t.message}&rdquo;</p>
                <div className="mt-3 text-sm">{t.name}</div>
                <div className="text-xs text-white/40 font-mono uppercase">{t.role}</div>
              </div>
              <button onClick={() => del(t.id)} className="text-white/60 hover:text-red-400"><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
      </div>

      {show && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" onClick={() => setShow(false)}>
          <div className="bg-[#131A2B] border border-white/12 p-8 max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h3 className="font-display text-2xl uppercase font-black">New Testimonial</h3>
              <button onClick={() => setShow(false)}><X size={18} /></button>
            </div>
            <div className="space-y-3">
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Name" className="w-full bg-transparent border border-white/20 py-3 px-4" />
              <input value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} placeholder="Role (e.g. Parent, U-14)" className="w-full bg-transparent border border-white/20 py-3 px-4" />
              <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Message" rows={4} className="w-full bg-transparent border border-white/20 py-3 px-4" />
              <input value={form.avatar_url} onChange={(e) => setForm({ ...form, avatar_url: e.target.value })} placeholder="Avatar URL (optional)" className="w-full bg-transparent border border-white/20 py-3 px-4" />
              <input type="number" min="1" max="5" value={form.rating} onChange={(e) => setForm({ ...form, rating: e.target.value })} placeholder="Rating (1-5)" className="w-full bg-transparent border border-white/20 py-3 px-4" />
              <div className="grid grid-cols-2 gap-3">
                <select value={form.source} onChange={(e) => setForm({ ...form, source: e.target.value })} data-testid="testimonial-source" className="bg-[#131A2B] border border-white/20 py-3 px-3">
                  <option value="">Source (default)</option>
                  <option value="google">Google review</option>
                </select>
                <input value={form.source_url} onChange={(e) => setForm({ ...form, source_url: e.target.value })} placeholder="Source URL (optional)" className="bg-transparent border border-white/20 py-3 px-4 text-xs font-mono" />
              </div>
              <button onClick={save} data-testid="testimonial-save" className="w-full bg-brand-blue text-white py-3 font-bold uppercase tracking-widest">Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
